export const METHOD_TEXT_ID = "ner_text";
export const METHOD_FILE_ID = "ner_file";
export const METHOD_FILE_TABLE_ID = "parser_table_document";
